// Model.js
// -----------------------
// @module Case
define("SuiteDB.SDBYMM.SDBYMM.Model", [
  "Backbone",
  "Utils",
  "SCModel",
  "Singleton",
  "underscore",
], function (Backbone, Utils, SCModelComponent, Singleton, _) {
  "use strict";

  var SCModel = SCModelComponent.SCModel;

  function SDBYMM() {
    SCModel.call(this);

    this.urlRoot = function () {
      return Utils.getAbsoluteUrl(
        // @ts-ignore
        getExtensionAssetsPath("Modules/SDBYMM/SuiteScript2/SDBYMM.Service.ss"),
        true
      );
    };
  }

  SDBYMM.prototype = Object.create(SCModel.prototype);
  SDBYMM.prototype.constructor = SDBYMM;
  return _.extend(SDBYMM, Singleton);
});
